import React, { PureComponent } from "react";
import {
  Metric,
  selectFormat,
  getCountryFlag,
  Error,
} from "components/Utils/Utils.js";

class WorldCupMatchesActuals extends PureComponent {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={260} />;
    }

    const COLORS = ["orange", "teal", "yellow"];

    const renderColumns = (data) =>
      data.map((result, index) => (
        <div className="mt-4 mb-4 d-inline-block width-300" key={index}>
          <div className="mx-2 d-flex">
            {result.chart && (
              <div className="progress progress-bar-lg cell-chart">
                <div
                  className={`progress-bar progress-bar-${COLORS[index]}`}
                  role="progressbar"
                  style={{
                    width: result.chart,
                  }}
                  aria-valuenow={result.chart}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            )}

            <div className="ml-2 d-flex justify-content-center align-items-center">
              {result.metric.value && (
                <Metric size={"xs"} value={result.metric.value} format="0,0" />
              )}
            </div>
          </div>
          <div className="mx-2 mt-4 d-flex align-items-center height-70">
            {result.metric_secondary?.value && (
              <span className="mr-2 ratings-circle">
                <Metric
                  size={"xxs"}
                  value={result.metric_secondary.value}
                  format={"%"}
                />
              </span>
            )}
            {result.metric_secondary_name && (
              <span className="mr-2 info-detail">
                {result.metric_secondary_name}
              </span>
            )}
            <div>
              {result.metric_tertiary_name && (
                <p className="mb-1 info-detail">
                  {result.metric_tertiary_name}
                </p>
              )}
              {result.chart_secondary && (
                <>
                  <div className="progress progress-bar-sm cell-chart progress-bar-bg-yellow">
                    <div
                      className="progress-bar progress-bar-teal"
                      role="progressbar"
                      style={{
                        width: result.chart_secondary,
                      }}
                      aria-valuenow={result.chart_secondary}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>

                  <div className="progress-bar-label d-flex justify-content-between">
                    <img
                      src={`https://d1fh34r1lqg2ii.cloudfront.net/logos/telemundo.svg`}
                      alt="Telemundo"
                      className="mt-1 channel-logo--xs"
                    />

                    <img
                      src="https://d1fh34r1lqg2ii.cloudfront.net/logos/fox.svg"
                      alt="FOX"
                      className="mt-1 channel-logo--xs"
                    />
                  </div>
                </>
              )}

              {result.metric_pregame && result.metric_gametime && (
                <div className="d-flex">
                  <div>
                    <span className="world-cup-tag world-cup-tag--gray">
                      Pre-Game
                    </span>
                    <div className="mt-1">
                      <Metric
                        size={"xxs"}
                        value={result.metric_pregame.value}
                        format={"0,0"}
                      />
                    </div>
                  </div>

                  <div>
                    <span className="world-cup-tag world-cup-tag--teal">
                      Gametime
                    </span>
                    <div className="mt-1">
                      <Metric
                        size={"xxs"}
                        value={result.metric_gametime.value}
                        format={"0,0"}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ));

    const renderRows = () =>
      data.matches.map((match, i) => (
        <div key={i}>
          <div className="d-inline-flex">
            <div className="mt-4 d-inline-block width-300">
              <div className="mb-1 info-heading">
                <span className="mr-1 world-cup-country-flag-icon">
                  {getCountryFlag(match.meta.teams[0].country)}
                </span>
                {match.meta.teams[0].team} vs{" "}
                <span className="mr-1 world-cup-country-flag-icon">
                  {getCountryFlag(match.meta.teams[1].country)}{" "}
                </span>
                {match.meta.teams[1].team}
              </div>
              <div className="mb-1 info-detail">
                Air Time:{" "}
                <span className="info-value">{match.meta.air_time}</span>
              </div>
              <div>
                <span className="info-detail">
                  Match: <span className="info-value">{match.meta.match}</span>
                </span>
                <span className="ml-2 info-detail">
                  Stage: <span className="info-value">{match.meta.stage}</span>
                </span>
              </div>

              <img
                src={`https://d1fh34r1lqg2ii.cloudfront.net/logos/${match.meta.network}.svg`}
                alt={`${match.meta.network}`}
                className="mt-2 channel-logo"
              />
            </div>

            {renderColumns(match.results)}
          </div>
        </div>
      ));

    return (
      <>
        <div className="row">
          <div className="mb-4 col-12">
            <small>All values are in Thousands (000)</small>
          </div>

          <div className="col-12">
            <div className="flex column-header--section">
              <span className="column-header">
                Matches as of{" "}
                {selectFormat("date", data.meta.date, "dddd MMMM Do YYYY")}
              </span>
              <span className="mx-2">|</span>

              <span>
                Match Days:{" "}
                <span className="column-header">{data.meta.match_day}</span>{" "}
                <span className="mx-2">|</span>
              </span>

              <span>
                Games Played:{" "}
                <span className="column-header">{data.meta.games_played}</span>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-4 overflow-auto">
          <div className="d-inline-flex row-divider-line-bottom">
            <div className="d-inline-block width-300">
              <div className="text-left column-header">Match</div>
            </div>
            <div className="d-inline-block width-300">
              <div className="mx-2 column-header">TAD Persons 2+</div>
            </div>
            <div className="d-inline-block width-300">
              <div className="mx-2 column-header">
                Telemundo Linear Persons 2+
              </div>
            </div>
            <div className="d-inline-block width-300">
              <div className="mx-2 column-header">Fox Linear Persons 2+</div>
            </div>
          </div>

          {renderRows()}
        </div>
      </>
    );
  }
}

export default WorldCupMatchesActuals;
